<template>
  <div>
    <List
      url="alarm_types/"
      :title="title"
      titleClass="title"
      :data="searchData"
      :tanle="tanle"
      :update="updateList"
      :is_admin="is_admin"
      :afterList="dealList"
      :operat="operat"
      :MultipleSel="true"
      @edit="edit"
      @deletedata="deletedata"
    >
      <div slot="Filter" style="display: block;">
        <label style="margin:20px 0px; margin-right:7px"
          >告警名称/告警码：</label
        >
        <el-input
          v-model="searchData.search"
          style="width:200px; margin-right:15px;"
          placeholder="告警名称/告警码"
        ></el-input>
        <el-button
          v-if="is_admin"
          @click="add"
          type="primary"
          style="margin:15px 0px; float:right"
          size="medium"
          >新增</el-button
        >
        <div style="display: flex;">
          <label style="margin:20px 0px; margin-right:7px">告警等级：</label>
          <el-checkbox-group
            style="margin:20px 0px; margin-right:30px;"
            v-model="level"
          >
            <el-checkbox
              style="font-size:16px;"
              v-for="alarmlevel in alarmlevels.slice(1, 6)"
              :label="alarmlevel.ID"
              :key="alarmlevel.ID"
              :value="alarmlevel.ID"
              >{{ alarmlevel.Name }}
            </el-checkbox>
          </el-checkbox-group>
          <el-button
            @click="search"
            type="primary"
            style="margin:15px 0px; margin-right:15px"
            size="small"
            >搜索</el-button
          >
        </div>
      </div>
    </List>
    <UpdateBox
      :initForm="updateForm"
      :updateType="updateType"
      v-if="updateBlock"
      @close="close"
      @update="updateList++"
    ></UpdateBox>
  </div>
</template>
<script>
import List from "../components/common/List.vue";
import UpdateBox from "../components/AlarmConfiguration/UpdateBox.vue";
import { Alarmlevels, alarmlevelsList } from "@/components/Index/data.js";
export default {
  components: {
    List,
    UpdateBox
  },
  data() {
    return {
      tanle: [
        { name: "name", label: "告警名称" },
        { name: "code", label: "告警码" },
        { name: "levelName", label: "告警等级" },
        { name: "threshold", label: "告警阈值" },
        { name: "description", label: "告警规则说明" }
      ],
      searchData: {
        search: "",
        level: ""
      },
      operat: [],
      updateType: "edit",
      updateList: 0,
      alarmlevels: alarmlevelsList,
      level: [],
      title: "告警配置列表",
      updateBlock: false,
      updateForm: {},
      is_admin: false
    };
  },
  mounted() {
    this.is_admin = JSON.parse(localStorage.getItem("is_admin"));
    if (this.is_admin) {
      this.operat = [
        {
          text: "Edit",
          eventName: "edit"
        },
        {
          text: "Deletedata",
          eventName: "deletedata"
        }
      ];
    }
  },
  methods: {
    dealList(data) {
      for (let i in data) {
        data[i].levelName = Alarmlevels[data[i].level];
      }
      return data;
    },
    close() {
      this.updateBlock = false;
    },
    search() {
      this.searchData.level = this.level.join(",");
      this.updateList++;
    },
    edit(val) {
      this.updateBlock = true;
      this.updateType = "edit";
      this.updateForm = Object.assign({}, val);
    },
    add() {
      this.updateBlock = true;
      this.updateType = "add";
      this.updateForm = {};
    },
    deletedata(val) {
      let url = "alarm_types/" + val.id + "/";
      this.$http["delete"](url, () => {
        this.$baseNotice.message("删除成功");
        this.updateList++;
      });
    }
  }
};
</script>
